import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})

export class FormControlsAndLogicsService {
  formControls={
    contact:{
      "firstname": {"length":50},
      "lastname": {"length":50},
      "emailaddress1": {"length":100},
      "mobilephone": {"length":10},
      "companyname": {"length":100},
      "aci_companysize": {"length":9},
      "address1_line1": {"length":250},
      "address1_city": {"length":80},
      "address1_postalcode": {"length":5},
      "address1_stateorprovince": {"length":50}
    },
    specialtyrxintakepage:{
      "firstname": {"length":50},
      "lastname": {"length":50},
      "emailaddress1": {"length":100},
      "mobilephone": {"length":10},
      "companyname": {"length":100},
      "websiteurl": {"length":200},
      "address1_line1": {"length":250},
      "address1_city": {"length":80},
      "address1_postalcode": {"length":5},
      "address1_stateorprovince": {"length":50},
      "aci_additionalinformationwhatcanwehelpyouwith": {"length":2000}
    },
    billing:{
      "aci_insurancename": {"length":400},
      "aci_noemployeeeligible": {"length":400},
      "aci_split_noemployeeligible": {"length":400}
    },
    clinic:{
      "aci_clinicname": {"length":100},
      "aci_cliniccontactname": {"length":100},
      "aci_onsitecontactlastname": {"length":100},
      "aci_cliniccontactphonenumber":{"length":10},
      "aci_streetaddress": {"length":100},
      "aci_city": {"length":100},
      "aci_state": {"length":100},
      "aci_otherimmunizationtype": {"length":100},
      "aci_estimateofdoses": {"length":6},
      "aci_clinicnoteimportantinformation": {"length":2000},
      "aci_otherservicetype": {"length":100},
    }
  }
  constructor() { }
}
